export default "__VITE_ASSET__55273180__"